import { Spacing, InsetSize, InlineChildrenAlignment } from '@doordash/design-language';

var ARROW_SIZE = 6;
var SPACING_FROM_NEAREST_CORNER = Spacing.XSmall;
var SPACING_FROM_ANCHOR = Spacing.XxSmall;
var TooltipContentAlignment = InlineChildrenAlignment;
var TooltipSize = {
  Small: InsetSize.XxSmall,
  Large: InsetSize.Small
};

export { ARROW_SIZE, SPACING_FROM_ANCHOR, SPACING_FROM_NEAREST_CORNER, TooltipContentAlignment, TooltipSize };
